// extracted by mini-css-extract-plugin
module.exports = {"root":"EditProjectListingDescriptionPanel_root__6RFAX","form":"EditProjectListingDescriptionPanel_form__3Mbbj","title":"EditProjectListingDescriptionPanel_title__3FQ2s"};